export default 'fonts/1fc9a5b4e5d40d2e76820837d22c61c1.woff';